import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { QRCodeSVG } from 'qrcode.react';
import Section from '../section';
import DefaultQrCode from '../../assets/default-qr-code.svg';
import './pix-qr-code.scss';

interface IPixQrCodeProps {
  pixData: string | null;
  amount?: number;
  coin?: string;
}

const PixQrCode: React.FC<IPixQrCodeProps> = ({
  pixData,
  amount,
  coin,
}) => {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    if (!pixData) return;

    try {
      await navigator.clipboard.writeText(pixData);
      setCopied(true);
      setTimeout(() => setCopied(false), 3000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  return (
    <Section
      className="pix-qr-code"
      title={t('PIX_QR_CODE.TITLE', { defaultValue: 'PIX Payment' })}
    >
      <div className="pix-qr-code-content">
        <div className="pix-qr-code-display" onClick={handleCopy} style={{ cursor: pixData ? 'pointer' : 'default', position: 'relative' }}>
          {pixData ? (
            <QRCodeSVG
              value={pixData}
              size={256}
              level="H"
              includeMargin={true}
              className="qr-image"
            />
          ) : (
            <div className="qr-placeholder">
              <img src={DefaultQrCode} alt="QR Code Placeholder" className="default-qr-icon" />
              <p>{t('PIX_QR_CODE.QR_PLACEHOLDER', { defaultValue: 'Scan QR Code in your bank app' })}</p>
            </div>
          )}
          {copied && (
            <div className="copied-notification">
              {t('PIX_QR_CODE.COPIED', { defaultValue: 'Copied!' })}
            </div>
          )}
        </div>

        <div className="pix-qr-code-hint">
          <p>{t('PIX_QR_CODE.SCAN_OR_CLICK', { defaultValue: 'Scan the QR code in your bank app or click to copy the payment link' })}</p>
        </div>

      </div>
    </Section>
  );
};

export default PixQrCode;

